import { Content } from '../../types';

export const thailandWeatherContent: Content = {
  title: 'עונות ומזג אוויר בתאילנד',
  imageUrl: '/images/thailand/thailand-weather/wide-weather.png',
  introduction:
    'תאילנד הינה יעד טרופי מובהק אשר משמעותו העיקרית הינה כי מזג האוויר לא באמת ניתן לחיזוי וכי מזג האוויר בזמן מסויים אינו מעיד על מזג האוויר באותו זמן בשנים אחרות ואף לא ביום אחר, מצב הטומן בחובו הפתעות לכאן ולכאן, אך, עם זאת, לסטטיסטיקה רבת השנים יש משמעות ומומלץ מאוד להסתמך עליה בעת שמתכננים טיול במדינה. בהתאם לסטטיסטיקה, מזג האוויר והאקלים בה אינם אחידים ומשתנים בהתאם לעונות השנה והאזורים השונים.',
  sections: [
    {
      title: 'העונות בתאילנד והשפעתן על האקלים והים',
      description:
        'נהוג לחלק את השנה לשלוש עונות עיקריות: העונה הקרה, העונה החמה ועונת הגשמים:',
      content: [
        {
          title: 'העונה הקרה (נובמבר - פברואר)',
          description:
            'זו התקופה הנוחה ביותר לטיול ברוב חלקי תאילנד. הטמפרטורות מתונות יחסית (20 - 28 מעלות במרכז ובצפון, 25 - 32 בדרום). בצפון ובצפון מזרח עשוי להיות קריר בלילות ואף קר בהרים. הים רגוע יחסית ברוב האזורים, הראות במים מצויינת וזו עונת השיא בתיירות.',
        },
        {
          title: 'העונה החמה (מרץ - מאי)',
          description:
            'טמפרטורות גבוהות מאוד, במיוחד באזורים פנימיים - ייתכן אף מעבר ל - 38 מעלות. לחות גבוהה באזורים הטרופיים, אך עדיין תקופה יבשה ברובה. מתאימה יותר לתכנון חופשת חופים או צלילות מאשר טיולי טבע רגליים.',
        },
        {
          title: 'עונת הגשמים (יוני - אוקטובר)',
          description:
            'מאופיינת בגשמים טרופיים, לרוב בצורת ממטרים חזקים וקצרים בשעות אחר הצהריים או הלילה. באיים המערביים (כפוקט וקאו לאק), הים סוער פי כמה, מה שמקשה על מעבר מעבורות ועל צלילות. האיים המזרחיים (כקו סאמוי ופנגאן) נהנים ממזג אוויר יציב, למעט החודשים ספטמבר - נובמבר, בהם מתגברים הגשמים.',
        },
      ],
      type: 'bullet-list',
      is12GoBanner: true,
    },
    {
      type: 'bullet-list',
      title: 'הזמנים המומלצים והפחות מומלצים באזורים השונים',
      content: [
        {
          title: "צפון תאילנד (צ'אנג מאי, צ'אנג ראי, פאי)",
          description:
            '<strong>הכי מומלץ: </strong> נובמבר - פברואר - אוויר קריר, שמיים בהירים, מתאים לטרקים או טיולי טבע. <br/><strong>פחות מומלץ: </strong> מרץ - מאי - חום כבד ותקופת שריפת השדות ("עונת האובך") שיוצרת תחושת מחנק באוויר. יולי - ספטמבר - גשמים חזקים שעלולים להגביל טיולים.',
        },
        {
          title: "מרכז תאילנד (בנגקוק, איוטאיה, קנצ'נבורי)",
          description:
            '<strong>הכי מומלץ: </strong> נובמבר - פברואר - נעים עבור טיולים עירוניים ותרבותיים. <br/><strong>פחות מומלץ: </strong> מרץ - מאי - עומס חום כבד. יולי - ספטמבר - גשמים רבים עם הצפות אפשריות בבנגקוק.',
        },
        {
          title:
            'האיים המערביים (פוקט, קראבי, קו פי פי, קאו לאק, קו לנטה, קו ליפה)',
          description:
            '<strong>הכי מומלץ: </strong> נובמבר - אפריל - ים רגוע, שמש, עונת שיא לצלילות. <br/><strong>פחות מומלץ: </strong> מאי - אוקטובר - ים סוער ובאזורים מסויימים, סגירת אתרי תיירות. צלילה בלתי אפשרית, אך מחירים זולים יותר.',
        },
        {
          title: 'האיים המזרחיים (קו סאמוי, קו פנגן, קו טאו)',
          description:
            '<strong>הכי מומלץ: </strong> פברואר - אוגוסט - מזג אוויר יציב יחסית, מתאים מאוד לחופשות בטן גב, לשנירקולים וצלילות. <br/><strong>פחות מומלץ: </strong> אוקטובר - ינואר - עונת המונסונים המקומית עם גשמים רבים וים סוער.',
        },
        {
          title: "האיים במרכז (קו צ'אנג, קו קוד, קו מק)",
          description:
            '<strong>הכי מומלץ: </strong> נובמבר - מאי - עונה יפה, ים רגוע, חופים נקיים. <br/><strong>פחות מומלץ: </strong> יוני - אוקטובר - גשמים חזקים, מלונות רבים נסגרים בעונה זו.',
        },
      ],
    },
    {
      title: 'מזג האוויר בתאילנד – חודש בחודשו',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: '',
          text: '<strong>ינואר: </strong>מזג אוויר קריר ונעים בכל המדינה. מתאים במיוחד לצפון תאילנד ולאיים המערביים.',
        },
        {
          subtitle: '',
          text: '<strong>פברואר: </strong>המשך מזג אוויר אידיאלי. באיים המזרחיים מתחילה עונה יבשה ויפה.',
        },
        {
          subtitle: '',
          text: '<strong>מרץ: </strong>מתחיל להיות חם מאוד במרכז ובצפון. מתאים יותר לחופים, המזרחיים והמערביים.',
        },
        {
          subtitle: '',
          text: '<strong>אפריל: </strong>חם מאוד בעיקר במרכז, חוגגים את פסטיבל סונגקראן (ראש השנה התאילנדי). פחות מתאים לטרקים. מתאים יותר לחופים, המזרחיים והמערביים.',
        },
        {
          subtitle: '',
          text: '<strong>מאי: </strong>לקראת עונת הגשמים. החום נשבר מעט, אך הלחות עולה. מתאים למחפשי שקט ותיירות זולה יותר, עם עדיפות לחופים, המזרחיים והמערביים.',
        },
        {
          subtitle: '',
          text: '<strong>יוני: </strong>גשמים מתחילים להתגבר בצפון ובמערב, אך קו סאמוי והאיים המזרחיים עדיין נהנים ממזג אוויר טוב.',
        },
        {
          subtitle: '',
          text: '<strong>יולי: </strong>המשך עונת גשמים, במיוחד בצפון ובמערב. במזרח עדיין אפשר לבלות.',
        },
        {
          subtitle: '',
          text: '<strong>אוגוסט: </strong>גשמים כמעט יומיומיים במערב ובצפון. במזרח תנאים טובים יותר.',
        },
        {
          subtitle: '',
          text: '<strong>ספטמבר: </strong>שיא עונת הגשמים בפוקט ובמערב. לא מומלץ לים.',
        },
        {
          subtitle: '',
          text: '<strong>אוקטובר: </strong>סוף עונת הגשמים, עדיין סוער יחסית. לקראת סוף החודש מזג אוויר מתייצב.',
        },
        {
          subtitle: '',
          text: '<strong>נובמבר: </strong>תחילת העונה הקרה. נעים בכל רחבי תאילנד, מתאים לטיול בכל האזורים.',
        },
        {
          subtitle: '',
          text: '<strong>דצמבר: </strong>אחד החודשים היפים ביותר – מזג אוויר אידיאלי, ים רגוע, אוויר קריר בצפון',
        },
      ],
    },
    {
      title: 'טבלה מזג האוויר לפי אזורים למול עונות:',
      type: 'text',
      content: `<div style="margin: 8px 0 12px; display: flex; gap: 16px; align-items: center; font-size: 14px;">
        <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#d4edda;border:1px solid #c3e6cb;"></span>מומלץ מאוד</span>
        <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#d1ecf1;border:1px solid #bee5eb;"></span>מומלץ</span>
        <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#f8d7da;border:1px solid #f5c6cb;"></span>פחות מומלץ</span>
      </div>
        <div style="overflow-x: auto; margin: 20px 0;">
        <table style="width: 100%; border-collapse: collapse; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); border-radius: 8px; overflow: hidden; font-size: 13px;">
          <thead>
            <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
              <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">אזור \\ חודש</th>
              <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">ינואר - פברואר</th>
              <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">מרץ - מאי</th>
              <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">יוני - אוקטובר</th>
              <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">נובמבר - דצמבר</th>
            </tr>
          </thead>
          <tbody>
            <tr style="background-color: #f8f9fa;">
              <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">צפון תאילנד</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">קריר ונעים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">חום כבד וזיהום אוויר</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת הגשמים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">קריר, מתאים לטרקים</td>
            </tr>
            <tr style="background-color: white;">
              <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">מרכז תאילנד</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חמים ונוח</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">חם מאוד</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">גשמים ולחות</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מזג אוויר נעים</td>
            </tr>
            <tr style="background-color: #f8f9fa;">
              <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">האיים המערביים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">עונת שיא</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">שמשי וים רגוע</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">לא ים סוער, גשמים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">עונת שיא</td>
            </tr>
            <tr style="background-color: white;">
              <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">האיים המזרחיים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">ינואר - עונת המונסונים<br/>פברואר - עונה יבשה ונעימה</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם ומתאים לחופשת בטן גב</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מומלץ בחלקו - יציב עד אוגוסט<br/>ספטמבר - אוקטובר, גשום</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">עונת המונסונים</td>
            </tr>
            <tr style="background-color: #f8f9fa;">
              <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">קו צ'אנג וקו קוד</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם ויבש יחסית</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">לא גשמים רבים</td>
              <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
            </tr>
          </tbody>
        </table>
      </div>`,
    },
    {
      title: '',
      content: `
      <div style="margin: 16px 0;">
        <a href="#months-modal" style="display: inline-flex; align-items: center; gap: 6px; background: #ff6b6b; color: #ffffff; text-decoration: none; font-weight: 700; padding: 7px 12px; border-radius: 10px; box-shadow: 0 2px 6px rgba(0,0,0,0.15); font-size: 13px;">
          <span style="font-size: 12px; opacity: 0.9;">🔗</span>
          לפירוט מלא של מזג האוויר לפי חודשים
        </a>
      </div>

      <style>
        #months-modal { display: none; }
        #months-modal:target { display: flex; }
      </style>

      <div id="months-modal" style="position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 1000; align-items: center; justify-content: center; padding: 24px;">
        <div role="dialog" aria-modal="true" style="width: 100%; max-width: 1100px; background: #ffffff; border-radius: 12px; box-shadow: 0 10px 30px rgba(0,0,0,0.25); overflow: hidden;">
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff;">
            <div style="font-weight: 700;">טבלת מזג האוויר לפי חודשים למול אזורים</div>
            <a href="#close-modal" aria-label="סגור" style="background: transparent; border: none; color: #fff; font-size: 22px; cursor: pointer; text-decoration: none; line-height: 1;">×</a>
          </div>
          <div style="padding: 16px; max-height: 80vh; overflow: auto;">
            <div style="margin: 0 0 12px; display: flex; gap: 16px; align-items: center; font-size: 14px;">
              <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#d4edda;border:1px solid #c3e6cb;"></span>מומלץ מאוד</span>
              <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#d1ecf1;border:1px solid #bee5eb;"></span>מומלץ</span>
              <span style="display:inline-flex; align-items:center; gap:6px;"><span style="width:14px;height:14px;border-radius:3px;background:#f8d7da;border:1px solid #f5c6cb;"></span>פחות מומלץ</span>
            </div>
            <div style="overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); border-radius: 8px; overflow: hidden; font-size: 13px;">
                <thead>
                  <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">חודש</th>
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">צפון תאילנד</th>
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">מרכז תאילנד</th>
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">האיים המערביים</th>
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">האיים המזרחיים</th>
                    <th style="padding: 15px 12px; text-align: center; font-weight: 600; font-size: 14px; border: none;">קו צ'אנג וקו קוד</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">ינואר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">קריר ונעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">נעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">עונת מונסונים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">פברואר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">מזג אוויר נעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חמים ונעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">עונה יפה</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מזג אוויר נעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">עונה יפה</td>
                  </tr>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">מרץ</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">חם מאוד</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">חם</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">שמשי</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם אך מתאים לים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם ויבש</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">אפריל</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">חום כבד</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">שיא החום</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם וים רגוע</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם ויבש</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">חם</td>
                  </tr>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">מאי</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">תחילת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">תחילת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">תחילת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">יציב</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">תחילת גשמים</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">יוני</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת הגשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">גשום ולח</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">ים סוער</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מומלץ -מתאים לחופשה</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשמים רבים</td>
                  </tr>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">יולי</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת הגשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשמים וים גבוה</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מזג אוויר טוב</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">עונת גשמים</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">אוגוסט</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת הגשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">גשמים חזקים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשמים רבים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">יציב יחסית</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשום מאוד</td>
                  </tr>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">ספטמבר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">עונת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">שיטפונות אפשריים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">סוער מאוד</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">מומלץ בחלקו - גשמים מתחילים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשום וסוער</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">אוקטובר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">סוף עונת גשמים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">שיפור מזג האוויר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשמים רבים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">עונת מונסונים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">סוף גשמים</td>
                  </tr>
                  <tr style="background-color: #f8f9fa;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">נובמבר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">מזג אוויר קריר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d1ecf1;">נעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">חזרה לעונה היפה</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">גשום מאוד</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">חזרה לעונה היפה</td>
                  </tr>
                  <tr style="background-color: white;">
                    <td style="padding: 12px; text-align: center; font-weight: 600; border: 2px solid #e9ecef;">דצמבר</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">קריר ונעים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">נעים ונוח</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #f8d7da;">עונת מונסונים</td>
                    <td style="padding: 12px; text-align: center; border: 2px solid #e9ecef; background-color: #d4edda;">ים רגוע</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      `,
      type: 'text',
    },
  ],
};
